import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
	getMeasurementDetailListQuery as getMeasurementDetailListQueryApi,
	addMeasurementDetailApi,
	updateMeasurementDetailApi,
	deleteMeasurementDetailApi,
} from '../../helpers/measurement_detail/api_helper';

export const getMeasurementDetailListQuery = createAsyncThunk(
	'measurementDetail/getMeasurementDetailListQuery',
	async params => {
		try {
			const response = getMeasurementDetailListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const addNewMeasurementDetail = createAsyncThunk(
	'measurementDetail/addNewMeasurementDetail',
	async data => {
		try {
			const response = await addMeasurementDetailApi(data);
			toast.success('Detalle de Medición agregado exitosamente.', { autoClose: 3000 });
			return response.data || response;
		} catch (error) {
			toast.error('Error al agregar el detalle de medición.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const updateMeasurementDetail = createAsyncThunk(
	'measurementDetail/updateMeasurementDetail',
	async data => {
		try {
			const response = await updateMeasurementDetailApi(data._id, data);
			toast.success('Detalle de Medición actualizado exitosamente.', { autoClose: 3000 });
			return response.data || response;
		} catch (error) {
			toast.error('Error al actualizar el detalle de medición.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteMeasurementDetail = createAsyncThunk(
	'measurementDetail/deleteMeasurementDetail',
	async measurementDetail => {
		try {
			await deleteMeasurementDetailApi(measurementDetail._id);
			toast.success('Detalle de Medición eliminado exitosamente.', { autoClose: 3000 });
			return measurementDetail;
		} catch (error) {
			toast.error('Error al eliminar el detalle de medición.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);
